/**
 * Safe Text utility function
 * Safely converts values to strings, handling objects (especially those with provider keys)
 * to prevent React rendering errors like "Objects are not valid as a React child"
 * 
 * @param {*} val - The value to convert to a safe string
 * @returns {string} A safe string representation of the value
 */
export const safeText = (val) => {
  if (val === null || val === undefined) return "—";
  if (typeof val === "object") {
    // If it's an object with common keys, extract them
    if ('provider' in val) {
      return String(val.provider || val.value || val.name || "—");
    }
    if ('title' in val) {
      return String(val.title || "—");
    }
    if ('name' in val) {
      return String(val.name || val.value || "—");
    }
    return "—";
  }
  return String(val);
};

/**
 * Normalize data source utility function
 * Ensures no objects are rendered directly in React components by converting
 * all object values to safe strings
 * 
 * @param {Array} data - The data array to normalize
 * @returns {Array} Normalized array with all object values converted to strings
 */
export const normalizeDataSource = (data) => {
  if (!data || !Array.isArray(data)) return [];
  return data.map(row => {
    const normalizedRow = {};
    Object.keys(row).forEach(key => {
      const value = row[key];
      if (typeof value === 'object' && value !== null) {
        normalizedRow[key] = safeText(value);
      } else {
        normalizedRow[key] = value;
      }
    });
    return normalizedRow;
  });
};

export default safeText;

